import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { VisualViewportService } from './core/services/visual-viewport.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatButtonModule, MatToolbarModule, MatIconModule],
  templateUrl: './app.html',
})
export class App {
  title = 'zenar-legal-admin';

  /** Applies the saved light / dark theme before any page renders. */
  private readonly theme = inject(ThemeService);

  /** Keeps dialogs above the on-screen keyboard on phones (see styles.scss). */
  private readonly visualViewport = inject(VisualViewportService);

  constructor() {
    // Older builds stored the login form (including the password) in plain text under these keys.
    // Nothing reads them; wipe them for users who logged in before that was removed.
    localStorage.removeItem('userCredsForToken');
    localStorage.removeItem('userCreds');
  }
}
